import React from 'react'
import ClassFinderDataLoader from './ClassFinderDataLoader'
import ReduxContainer from '../../reduxContainer/ReduxContainer'
import UserLoadWrapper from '../../reduxContainer/UserLoadWrapper'
import camelize from 'camelize'
import './classFinder.scss'
import {
  difficultyFilterOptions,
  intensityFilterOptions
} from './classFinderDropdownInfo'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

const DURATION_MIN = 0
const DURATION_MAX = 90

class ClassFinder extends React.Component {
  constructor(props) {
    super(props)

    const instructorFilterOptions = camelize(
      JSON.parse(props.instructorFilterOptions)
    )
    const categoryFilterOptions = camelize(
      JSON.parse(props.categoryFilterOptions)
    )
    const includeFilters = props.includeFilters
    const defaultOrder = props.defaultOrder

    this.metaInfo = {
      defaultValue: props.defaultValue,
      autopaginate: props.autopaginate,
      includeFilters,
      defaultOrder,
      preloadedFilters: this.getPreloadedFilters(),
      baseUrl: props.baseUrl,
      withSubcategories: props.withSubcategories,
      dropdownOptions: {
        duration: [],
        instructors: instructorFilterOptions,
        styles: categoryFilterOptions,
        intensities: intensityFilterOptions,
        difficulties: difficultyFilterOptions,
        focus_area: props.focusAreaTags,
        equipment: props.equipmentTags
      }
    }
  }

  getPreloadedFilters() {
    const instructors = this.generateFilteredParams(
      this.props.filteredInstructors
    )
    const styles = this.generateFilteredParams(this.props.filteredStyles)
    const difficulties = this.generateFilteredParams(
      this.props.filteredDifficulties
    )

    const filteredIntensities = this.generateFilteredParams(
      this.props.filteredIntensities
    )
    const intensities = filteredIntensities.map((intensity) =>
      parseInt(intensity, 10)
    )

    const equipment = this.generateFilteredParams(this.props.filteredEquipment)

    const focus_area = this.generateFilteredParams(this.props.filteredFocusArea)

    const excludeCompleted = this.props.excludeCompleted
    const duration =  this.generateFilteredParams(this.props.duration)

    return {
      instructors,
      styles,
      difficulties,
      intensities,
      equipment,
      focus_area,
      excludeCompleted,
      duration
    }
  }

  /**
   * Converts comma separated string of filters to array
   * @param {Comma separated string of filters} filtered
   */
  generateFilteredParams(filtered) {
    return filtered ? filtered.split(',') : []
  }

  render() {
    return (
      <ReduxContainer>
        <UserLoadWrapper>
          <ThemeProvider theme={LightTheme}>
            <div className='ClassFinder'>
              <ClassFinderDataLoader {...this.metaInfo} />
            </div>
          </ThemeProvider>
        </UserLoadWrapper>
      </ReduxContainer>
    )
  }
}

export default ClassFinder
